import adminApi from '@/api/admin';

const APPEND_SALES = 'APPEND_SALES';
const SET_IS_FETCHING = 'SET_IS_FETCHING';
const SET_IS_FETCHED = 'SET_IS_FETCHED';
const SET_IS_ALL = 'SET_IS_ALL';
const ADD_PAGE = 'ADD_PAGE';
const RESET_SALES = 'RESET_SALES';
const SET_PAGE_INFO = 'SET_PAGE_INFO';
const SET_ACTIVE_SALES = 'SET_ACTIVE_SALES';
const SET_UNSHIFT_SALES = 'UNSHIFT_SALES';

const state = {
	all: [],
	isFetching: false,
	isAll: false,
	page: 1,
	isFetched: false,
	pageInfo: null,
	activeSales: null,
};

const getters = {
	allSales: state => state.all,
	isFetching: state => state.isFetching,
	isAll: state => state.isAll,
	page: state => state.page,
	isFetched: state => state.isFetched,
	pageInfo: state => state.pageInfo,
	activeSales: state => state.activeSales,
};

const mutations = {
	[APPEND_SALES](state, sales) {
		state.all = state.all.concat(sales);
	},
	[RESET_SALES](state) {
		state.all = [];
		state.isAll = false;
		state.page = 1;
	},
	[SET_IS_FETCHING](state, status) {
		state.isFetching = status;
	},
	[SET_IS_FETCHED](state, status) {
		state.isFetched = status;
	},
	[SET_IS_ALL](state, status) {
		state.isAll = status;
	},
	[ADD_PAGE](state) {
		state.page++;
	},
	[SET_PAGE_INFO](state, pageInfo) {
		state.pageInfo = pageInfo;
	},
	[SET_ACTIVE_SALES](state, activeSales) {
		state.activeSales = activeSales;
	},
	[SET_UNSHIFT_SALES](state, sales) {
		state.all.unshift(sales);
	},
};

const actions = {
	getSales({ commit, getters }, params) {
		if (!getters.isFetching) {
			commit(SET_IS_FETCHING, true);
			const callback = (response) => {
				const sales = response.data;
				if (response.data?.page_info) {
					const pageInfo = response.data.page_info;
					commit(SET_PAGE_INFO, pageInfo);
				}
				if (sales !== null && sales.length !== 0) {
					commit(APPEND_SALES, sales);
					commit(ADD_PAGE);
				} else {
					commit(SET_IS_ALL, true);
				}
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_FETCHED, true);
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				commit(SET_IS_FETCHED, true);
			};
			adminApi.getSales(params, callback, errorCallback);
		}
	},
	resetSales({ commit }) {
		commit(RESET_SALES);
	},
	setActiveSales({ commit }, params) {
		commit(SET_ACTIVE_SALES, params);
	},
	setUnshiftSales({ commit }, params) {
		commit(SET_UNSHIFT_SALES, params);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
